<template>
  <div class="transition" :style="bgstyle">
    <div class="topbumper"></div>
    <div class="bottombumper"></div>
  </div>
</template>

<script>
export default {
  name: "Transition",
  props: ["start", "end"],
  computed: {
    bgstyle: function () {
      var gradstyle = {
        background:
          "linear-gradient(180deg, " +
          this.start.toString() +
          " 0%, " +
          this.end.toString() +
          " 100%)",
      };
      return gradstyle;
    },
  },
};
</script>

<style scoped>
.transition {
  height: 50px;
  width: 100%;
}
.bottombumper {
  scroll-snap-align: end;
}
</style>
